import { CropFreeRounded } from "@mui/icons-material";
import { Badge, Button, Stack } from "@mui/material";
import { TeamPicker } from "../../../components";
import { useSettings } from "../../../hooks";
import { OrganizationNetworkGraphRef } from "./OrganizationNetworkGraph";

interface IProps {
  organizationNetworkGraphRef: React.RefObject<OrganizationNetworkGraphRef>;
}

const HomeToolbar = (props: IProps) => {
  const { homeSettings, updateHomeSettings } = useSettings();

  function handleVisualizationModeChanged() {
    updateHomeSettings({
      ...homeSettings,
      showPeople: !homeSettings.showPeople,
    });
  }

  function handleTeamSelected(selectedTeamGuids: string[]) {
    updateHomeSettings({
      ...homeSettings,
      selectedTeamGuids: selectedTeamGuids,
    });
  }

  function handleTeamsCleared() {
    updateHomeSettings({
      ...homeSettings,
      selectedTeamGuids: [],
    });
  }

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        width: "100%"
      }}>
      <Stack direction="row" spacing={0.5}>
        <Badge color="primary" variant="dot" invisible={homeSettings.selectedTeamGuids.length === 0}>
          <TeamPicker
            selectedTeamGuids={homeSettings.selectedTeamGuids}
            onTeamSelected={handleTeamSelected}
            onClearClicked={handleTeamsCleared}
          />
        </Badge>
        <Button variant="tertiary" onClick={handleVisualizationModeChanged}>
          {homeSettings.showPeople ? "Hide People" : "Show People"}
        </Button>
      </Stack>
      <Button
        variant="tertiary"
        startIcon={<CropFreeRounded />}
        onClick={() => props.organizationNetworkGraphRef.current?.zoomToFit()}
      >
        Zoom To Fit
      </Button>
    </Stack>
  );
};

export { HomeToolbar };
